import AreaSubstrateView from './AreaSubstrateView'
export default AreaSubstrateView
